export const TARGET_EMAIL = 'jesus.paredes@factormashealth.com.mx';
export const GOOGLE_DRIVE_CDN = 'https://lh3.googleusercontent.com/d/';